import {
  RecordingFragment,
  getError,
  getTypeOrNull,
} from '@spotify/confidence-graphql';

type RecordingDownload = {
  downloadUri: string | undefined;
  downloadError: Error | undefined;
};

export const getRecordingDownload = (
  recording: RecordingFragment | undefined,
): RecordingDownload => {
  const downloadRecording = getTypeOrNull(recording?.downloadRecording);
  if (downloadRecording) {
    return {
      downloadUri: downloadRecording.downloadUri,
      downloadError: undefined,
    };
  }
  return {
    downloadUri: undefined,
    downloadError: getError(recording?.downloadRecording) ?? undefined,
  };
};
